import React from 'react';
import Icons from './Icons';

export default function InstagramConnectModal({ onClose }) {
  const handleConnect = () => {
    const jwt = localStorage.getItem('token') || '';
    const returnTo = `${window.location.origin}?ig=connected`;
    const base = `${process.env.REACT_APP_BACKEND_URL}/api/ig/oauth/start`;
    const url = `${base}${jwt ? `?token=${encodeURIComponent(jwt)}` : ''}&return_to=${encodeURIComponent(returnTo)}`;
    window.location.assign(url);
  };

  return (
    <>
      <div
        style={{ position: 'fixed', inset: 0, zIndex: 9998, background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)' }}
        onClick={onClose}
      />
      <div style={{ position: 'fixed', inset: 0, zIndex: 9999, overflowY: 'auto' }}>
        <div style={{ minHeight: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: 'var(--surface-2)', border: '1px solid var(--border-default)',
              borderRadius: 20, padding: '2rem 1.5rem', width: '100%', maxWidth: 380,
              boxShadow: '0 24px 80px rgba(0,0,0,0.8)',
            }}
          >
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <div style={{
                width: 56, height: 56, borderRadius: '50%',
                background: 'linear-gradient(135deg, #6366f1, #ec4899)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 16px',
              }}>
                <Icons.Instagram style={{ width: 28, height: 28, color: '#fff' }} />
              </div>
              <h2 style={{ fontSize: '1.125rem', fontWeight: 600, color: '#fff', marginBottom: 8 }}>
                Connect Instagram
              </h2>
              <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
                Link your Creator or Business account to unlock scheduling, scanner, and accurate NIL scores.
              </p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <button className="btn-primary" style={{ width: '100%', justifyContent: 'center' }} onClick={handleConnect}>
                <Icons.Instagram style={{ width: 18, height: 18 }} />
                Connect Instagram Account
              </button>
              <button className="btn-secondary" style={{ width: '100%', justifyContent: 'center', fontSize: '0.8rem' }} onClick={onClose}>
                Skip for now
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
